import styled from 'styled-components';

import Heading from '/components/ui/Heading';
import Description from '/components/ui/typography/Description';
import Paragraph from '/components/ui/Paragraph';
import Editable from '/components/Editable';
import { colors } from '/css';
import decorateText from '/lib/utils/decorateText';

interface Props {
    className?: string;
    theme?: 'default' | 'job-list';
    editable?: boolean;
    onChange?: (val: string) => void;
    children: string;
}

const ImportantInformation = ({
    children,
    className,
    theme = 'default',
    editable,
    onChange,
}: Props) => {
    const isEditable = editable && onChange;
    return (
        <Wrapper className={className} theme={theme}>
            {theme === 'default' && (
                <Heading medium tag="div" className="label mb-24">
                    Viktig informasjon
                </Heading>
            )}
            {theme === 'job-list' && (
                <Description className="label mb-16">
                    Viktig informasjon
                </Description>
            )}

            {!isEditable ? (
                <div className="panel pt-24 pb-32 pl-32 pr-32">
                    <Paragraph medium>{decorateText(children)}</Paragraph>
                </div>
            ) : (
                <Editable
                    placeholder="Viktig informasjon"
                    className="paragraph-medium pt-24 pb-24 pl-32 pr-32 bg-orange-light br"
                    onChange={onChange}
                    value={children}
                />
            )}
        </Wrapper>
    );
};

export default ImportantInformation;

const Wrapper = styled.div`
    .label {
    }
    .panel {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        background: ${colors.orangeM4};
        border-radius: 12px;
    }

    ${(props) =>
        props.theme === 'job-list'
            ? `
        .panel {
            padding: 16px 24px 20px!important;
            p {
                font-size: 17px;
                line-height: 26px;
            }
        }
    `
            : ``}
`;
